import axios from 'axios';
import { API } from './api';

export const http = axios.create({
  baseURL: API,
});

http.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers = config.headers ?? {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      // stale/invalid token -> clean up and force re-auth
      localStorage.removeItem('authToken');

      // redirect to login
      window.location.href = '/login'; // or "/admin/login"
    }
    return Promise.reject(error);
  },
);
